import { isEqual, cloneDeep } from 'lodash'
import { POST } from '@/api'
import detail from './detail'

const MAX_WIDTH = 1424
const MAX_HEIGHT = 960
const DEFAULT_VIEW_BOX = `${MAX_WIDTH / 4} ${MAX_HEIGHT / 4} ${MAX_WIDTH / 2} ${MAX_HEIGHT / 2}`

const initialFloor = {
  id: 1,
  name: 'フロア１',
  tables: [],
  parts: [],
  viewBox: DEFAULT_VIEW_BOX,
}

export default {
  namespaced: true,
  state: {
    tmp: {},
    layout: {
      id: null,
      name: '',
      floors: [],
    },
    busy: false,
  },
  modules: {
    detail,
  },
  mutations: {
    set(state, layout) {
      const initLayout = {
        ...state.detail.layout,
        floors: state.detail.layout.floors.map(floor => ({ ...initialFloor, ...floor })),
      }
      state.layout = cloneDeep(layout || initLayout)
      state.tmp = cloneDeep(state.layout)
    },
    setTmp(state) {
      state.tmp = cloneDeep(state.layout)
    },
    update(state, value) {
      state.layout = { ...state.layout, ...value }
    },
    updateFloor(state, { index, ...floor }) {
      const floors = [...state.layout.floors]
      floors[index] = { ...floors[index], ...floor }
      state.layout.floors = floors
    },
    deleteFloor(state, index) {
      state.layout.floors = state.layout.floors.filter((_, i) => i !== index)
    },
    addFigure(state, { floor, type, item }) {
      state.layout.floors[floor][type] = state.layout.floors[floor][type].concat(item)
    },
    updateFigure(state, { floor, type, index, value }) {
      const floors = cloneDeep(state.layout.floors)
      Object.assign(floors[floor][type][index], value)
      state.layout.floors = floors
    },
    deleteFigure(state, { floor, type, index }) {
      state.layout.floors[floor][type] = state.layout.floors[floor][type].filter((_, i) => i !== index)
    },
    reset(state) {
      state.layout = cloneDeep(state.detail.layout)
    },
    resetTmp(state) {
      state.layout = cloneDeep(state.tmp)
    },
    busy(state, value) {
      state.busy = value
    },
  },
  getters: {
    changed(state) {
      return !isEqual(state.layout, {
        ...state.detail.layout,
        floors: state.detail.layout.floors.filter(floor => floor.name),
      })
    },
    changedTmp(state) {
      return !isEqual(state.layout, state.tmp)
    },
    tableIds({ layout }) {
      return layout.floors.reduce((tableIds, floor) => tableIds.concat(floor.tables.map(table => table.id)), [])
    },
  },
  actions: {
    async save(store) {
      const { state, commit } = store
      if (state.busy) return
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/layouts/regist', { ...state.layout })
      if (status === 200) {
        if (data && data.id) {
          commit('update', { id: data.id })
        }
        commit('set', state.layout)
        commit('detail/set', state.layout)
      } else {
        commit('app/error', { status, message }, { root: true })
      }
      commit('busy', false)
    },
  },
}
